import { render } from "./MobileCategoryNav.vue?vue&type=template&id=4a8b7012&scoped=true"
import script from "./MobileCategoryNav.vue?vue&type=script&lang=js"
export * from "./MobileCategoryNav.vue?vue&type=script&lang=js"

import "./MobileCategoryNav.vue?vue&type=style&index=0&id=4a8b7012&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8b7012"]])

export default __exports__